import { z } from 'zod/v4';

/** Only the Name dimensions with a defined, reader-independent value are supported. */
export const CalculationNameFilterNodeTypeRuntype = z.enum([
    'Manufacturer',
    'SupplierManufacturer',
    'Supplier',
    'PartCategory',
]);

export const CalculationNameFilterConditionRuntype = z.union([
    z.object({
        operation: z.enum(['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith']),
        value: z.string().max(1000),
    }),
    z.object({ operation: z.enum(['blank', 'notBlank']) }),
]);

export const CalculationNameFilterRuntype = z.object({
    nodeType: CalculationNameFilterNodeTypeRuntype,
    operator: z.enum(['AND', 'OR']),
    conditions: z.array(CalculationNameFilterConditionRuntype).min(1).max(10),
});

/** Different Name columns combine with AND; each column can preserve a saved AND/OR model. */
export const CalculationNameFiltersRuntype = z.array(CalculationNameFilterRuntype).max(3);
export type CalculationNameFilter = z.infer<typeof CalculationNameFilterRuntype>;
export type CalculationNameFilterCondition = z.infer<typeof CalculationNameFilterConditionRuntype>;
